import { FolderResponse } from '../schemas'
import { FolderOverflowMenu } from './FolderOverflowMenu'
import { DriveListItem } from '@/user_files/drive/components/drive-list-item/DriveListItem'
import { formatDriveListUpdatedAtParts } from '@/user_files/utils/drive-list-format'
import { matterPaths } from '@/routing/paths'
import { useNavigate, useParams } from 'react-router-dom'

interface FolderListItemProps {
  folder: FolderResponse
  disabled?: boolean
  selected?: boolean
  onToggleSelect?: () => void
  onRename?: () => void
  onMove?: () => void
  onDelete?: () => void
}

/**
 * FolderListItem
 *
 * Single folder row in the folder list. Clicking the row navigates into that folder.
 * Checkbox click toggles selection without navigating.
 *
 * Navigation is user-action-driven (not effect-driven) to ensure clean browser history.
 * The URL change triggers the URL → Redux sync effect in UserFilesFolderRouteHandler.
 */
export function FolderListItem({ folder, disabled, selected, onToggleSelect, onRename, onMove, onDelete }: FolderListItemProps) {
  const navigate = useNavigate()
  const { matterId } = useParams<{ matterId: string }>()

  const handleClick = () => {
    if (!matterId) return

    // Navigate directly - URL change will trigger Redux sync
    navigate(matterPaths.userFiles.folder(matterId, folder.id))
  }

  const { date, time } = formatDriveListUpdatedAtParts(folder.updated_at)

  return (
    <DriveListItem
      variant="folder"
      name={folder.name}
      formattedDate={date}
      formattedTime={time}
      disabled={disabled}
      selected={selected}
      onToggleSelect={onToggleSelect}
      onClick={handleClick}
      overflowMenu={<FolderOverflowMenu onRename={onRename} onMove={onMove} onDelete={onDelete} />}
    />
  )
}
